import React, { useEffect, useState } from "react";
import { HelpCircle } from "lucide-react";
import api from "@/lib/api";
import { useLang } from "@/context/LanguageContext";
import { useSEO } from "@/hooks/useSEO";
import { SectionHeading, EmptyState } from "@/components/shared/SectionHeading";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export default function Faq() {
  const { t } = useLang();
  useSEO("FAQ", "Frequently asked questions about INVIXA VIP, brokers and education.");
  const [faqs, setFaqs] = useState(null);
  useEffect(() => { api.get("/faqs").then((r) => setFaqs(r.data)).catch(() => setFaqs([])); }, []);

  return (
    <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8 py-16">
      <SectionHeading center eyebrow="FAQ" title={t("faq")} />
      <div className="mt-10">
        {faqs === null ? <div className="text-center text-slate-500 py-20">{t("loading")}</div>
          : faqs.length === 0 ? <EmptyState message="No FAQs published yet." icon={HelpCircle} />
          : (
            <Accordion type="single" collapsible data-testid="faq-accordion">
              {faqs.map((f) => (
                <AccordionItem key={f.id} value={f.id} className="card-surface rounded-xl mb-3 px-5 border-white/10">
                  <AccordionTrigger className="text-white hover:no-underline text-left" data-testid={`faq-q-${f.id}`}>{f.question}</AccordionTrigger>
                  <AccordionContent className="text-slate-400 leading-relaxed">{f.answer}</AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          )}
      </div>
    </div>
  );
}
